import React from "react";
import "./Home.css";
import blogimg from "../../assets/images/blogimg.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

const defaultBlogs = [
  {
    blog_id: 1,
    blog_title: "How To Bring Down The HbA1c Level?",
    blog_fimage: blogimg,
    blog_created: "",
  },
  {
    blog_id: 2,
    blog_title:
      "How Traditional Indian Food Can Help in Controlling Your Diabetes",
    blog_fimage: blogimg,
    blog_created: "",
  },
  {
    blog_id: 3,
    blog_title: "5 Ways to Prevent the Third Wave of COVID-19 in India",
    blog_fimage: blogimg,
    blog_created: "",
  },
  {
    blog_id: 4,
    blog_title: "Important Nutrition for Our Body",
    blog_fimage: blogimg,
    blog_created: "",
  },
];

function Blog({ blogs = [] }) {
  const displayBlogs = blogs.length > 0 ? blogs : defaultBlogs;

  return (
    <div className="blog_section">
      <div className="container-fluid">
        <div className=" row text-center center-heading">
          <div className="content_part col-lg-12 col-sm-12 col-12">
            <h4>Product Rental Guides For You</h4>
            <p>
              Explore helpful articles about products available on rent, rental
              options, usage tips, and everything you need to know before
              choosing the right product for your needs.
            </p>
          </div>
        </div>

        <div className="slider-wrapper">
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={24}
            slidesPerView={3}
            centeredSlides={false}
            loop={displayBlogs.length > 3}
            autoplay={{ delay: 5500, disableOnInteraction: false }}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 12,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            {displayBlogs.map((item) => {
              const detailLink = `/blog/${item.blog_slug || item.blog_id}`;
              const formattedDate = item.blog_created
                ? new Date(item.blog_created).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "";

              return (
                <SwiperSlide key={item.blog_id}>
                  <div className="blog-main">
                    <div className="blog-inner">
                      <div className="blog-img-box">
                        <Link to={detailLink}>
                          <img
                            src={item.blog_fimage || blogimg}
                            alt={item.blog_title}
                            className="img-fluid"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = blogimg;
                            }}
                          />
                        </Link>
                      </div>
                      {formattedDate && (
                        <label className="blog-date">{formattedDate}</label>
                      )}
                      <h4>
                        <Link to={detailLink} className="blog-title-link">
                          {item.blog_title}
                        </Link>
                      </h4>
                      <div className="blog-card-footer">
                        <button className="read-more-btn">
                          <Link to={detailLink}>Read More</Link>
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default Blog;
